import React, { Component } from "react";
//import TableComp from '../../../../components/_utils/table'
import { TableComp } from "sz-react-utils";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import {
  Button,
  Card,
  Col,
  notification,
  Popconfirm,
  Row,
  Tooltip,
} from "antd";
import Request from "../../../../request";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import styles from "../../country/all/styles.less";
import rightAuth from "../../../../components/_utils/userRights";
import { RightsWrapper } from "../../../../components/_utils/utils";

class AllRestrictedUniversity extends Component {
  state = {
    count: 0,
    exportLoading: false,
  };

  constructor(props) {
    super(props);

    this.table = React.createRef();
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      this.setState({ exportParams: params });
      let data = await Request.loadRestrictedUniversities({
        ...params,
        regExFilters: ["universityName"],
      });

      this.setState({ count: data.total });

      resolve(data);
    });
  };

  componentDidMount() {}

  handleDelete = (val) => {
    Request.deleteRestrictedUniversity(val)
      .then((x) => {
        if (x.success) {
          notification.success({
            message: x.msg,
            description: x.msg,
          });
        } else {
          notification.error({
            message: "Error",
            description: x.msg,
          });
        }
        this.table.current.reload();
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: "Some Error",
        });
      });
  };

  render() {
    const columns = [
      {
        title: "Board",
        key: "universityName",
        dataIndex: "universityName",
        width: 100,
        fixed: "left",
        sorter: true,
        searchTextName: "universityName",
        filterRegex: true,
        render: (val, record) => {
          return <React.Fragment>
              {rightAuth.checkRights("RestrictedLocalUniversity.edit") ? <RightsWrapper myRight={"RestrictedLocalUniversity.edit"}>
                  <Tooltip title="Click To Edit Details">
                    <a href={`/master/edit-board?_id=${record._id}`}>
                      {record.universityName}
                    </a>
                  </Tooltip>
                </RightsWrapper> : <React.Fragment>
                  {record.universityName}
                </React.Fragment>}
            </React.Fragment>;
        },
      },
      {
        title: "Country",
        key: "country",
        width: 80,
        dataIndex: "country",
        render: (val, record) => {
          return (
            <div>
              {record.countryId ? record.countryId.countryName : ""}
            </div>
          );
        },
      },
      {
        title: "State",
        key: "state",
        width: 80,
        dataIndex: "state",
        render: (val, record) => {
          return (
            <div>
              {record.stateId ? record.stateId.stateName : ""}
            </div>
          );
        },
      },
      {
        title: "City",
        key: "city",
        width: 80,
        dataIndex: "city",
        render: (val, record) => {
          return (
            <div>{record.cityId ? record.cityId.cityName : ""}</div>
          );
        },
      },
      {
        title: "Action",
        key: "operation",
        width: 100,
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={"RestrictedLocalUniversity.delete"}>
              <Tooltip title="Delete Restricted Local University">
                <Popconfirm
                  title="Are you sure to delete Restricted Local University?"
                  onConfirm={() => this.handleDelete(record._id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button shape="circle" className={styles.btn} icon="delete" />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        ),
      },
    ];
    return (
      <PageHeaderWrapper title={`Total Restricted Local University : ${this.state.count}`}>
        <Card style={{ marginBottom: 10 }}>
          <Row>
            <Col span={12}>
            </Col>
            <Col span={10}>
            </Col>
            <Col span={2}>
                <div style={{textAlign: 'right', marginTop: '15px'}}>
                    <Link to='/master/add-restricted-local-university'><Button>Add</Button></Link>
                </div>
            </Col>
          </Row>
        </Card>
        <Card bordered={true}>
          <TableComp
            columns={columns}
            ref={this.table}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 1200 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllRestrictedUniversity);
